import { useEffect } from 'react';

const SITE_URL = 'https://preative.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

// Updates document title + meta/OG/canonical tags for the active route.
// Client-side only (no SSR), but combined with distinct routes + sitemap.xml
// this still gives each page its own indexable title/description.
const Seo = ({ title, rawTitle, description, path = '/', image = DEFAULT_IMAGE }) => {
  useEffect(() => {
    const fullTitle = rawTitle || (title ? `${title} | Preative Solutions` : 'Preative Solutions');
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setMeta('name', 'description', description);
    setLink('canonical', url);

    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', image);

    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', image);
  }, [title, rawTitle, description, path, image]);

  return null;
};

export default Seo;
